import { render, staticRenderFns } from "./VenueManagement.vue?vue&type=template&id=e65f627e&scoped=true"
import script from "./VenueManagement.vue?vue&type=script&lang=js"
export * from "./VenueManagement.vue?vue&type=script&lang=js"
import style0 from "./VenueManagement.vue?vue&type=style&index=0&id=e65f627e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65f627e",
  null
  
)

export default component.exports